export const feedbackRoutes = {
  FEEDBACK: "/email/feedback",
  SCHOOL_REQUEST_EMAIL: "/email/application",
  PERSONAL_TRAINING_REQUEST_EMAIL: "/email/training",
  LOGGER_SENDING_DATA: "/frontend-log",
}